import ClaimStoreCreditsModal from './ClaimStoreCreditsModal';

export default ClaimStoreCreditsModal;
